import { EnvironmentProviders, importProvidersFrom, Provider } from '@angular/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import {
  cloudMessagingProviders,
  ExternalScannerModule,
  InputScannerModule,
  IntegratedScannerModule,
  NfcReaderModule,
  ScannerModule,
  SOFTLINE_CONFIG_APP_INFO,
} from '@softline/application';
import {
  browserCloudMessagingProviders,
  BrowserModule,
  browserNfcReaderProviders,
  Html5ScannerModule,
  pwaProviders,
} from '@softline/browser';
import { version } from '../../../../version';
import { customerConfig } from '../customer-config';

const providePlatformPWA = (environment: any): Array<Provider | EnvironmentProviders> => {
  const providers: Array<Provider | EnvironmentProviders> = [
    importProvidersFrom(
      BrowserModule.forRoot(),
      ScannerModule.forRoot(),
      InputScannerModule.forRoot(),
      Html5ScannerModule.forRoot(),
      ExternalScannerModule.forRoot(),
      IntegratedScannerModule.forRoot(),
      NfcReaderModule.forRoot(),
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.production,
        registrationStrategy: 'registerWhenStable:30000',
      })
    ),
    ...pwaProviders,
    ...browserNfcReaderProviders,
    {
      provide: SOFTLINE_CONFIG_APP_INFO,
      useValue: {
        ...customerConfig,
        version: version,
      },
    },
  ];

  if (customerConfig.oneSignalAppId) {
    providers.push(
      ...cloudMessagingProviders({
        oneSignalAppId: customerConfig.oneSignalAppId,
      }),
      ...browserCloudMessagingProviders
    );
  }

  return providers;
};

export const providePlatform = providePlatformPWA;
